export default "__VITE_ASSET__D7v03G_z__"